module.exports = __webpack_public_path__ + "img/hall-str.c7b95598.svg";